export default __webpack_public_path__ + "static/media/2h.ecf0da0f.png";